import { render, staticRenderFns } from "./GlobalSearchResults.vue?vue&type=template&id=4608fe00&scoped=true&"
import script from "./GlobalSearchResults.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSearchResults.vue?vue&type=style&index=0&id=4608fe00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4608fe00",
  null
  
)

export default component.exports